
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FieldItemProps } from ".";
import { loading, fieldRemove, endLoading } from "store/form";

interface ApiFieldRemoveInputProps {
    ids: number[]
}

type ApiFieldRemoveOutputProps = OutputBaseProps<{ item: FieldItemProps; }>

export const apiFieldRemove = async (data: ApiFieldRemoveInputProps, formId: number) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiFieldRemoveOutputProps>(`/api/form/${formId}/field/remove`, { data }))
        .data;
    if (res.status) {
        store.dispatch(endLoading());
    }
    store.dispatch(endLoading());
    return res;
};